export default "__VITE_ASSET__BrZh1fcJ__"